import React, {Component} from 'react';
import { withRouter } from 'react-router-dom'

import Container from "./container/Container";
import PropTypes from "prop-types";
import VisibleEvent from "./VisibleEvent";
import Loader from "./Loader";
import SkeletonList from "./SkeletonList";
import SwitchingBanner from "./ads/SwitchingBanner";
import SubscribeButton from "./SubscribeButton";

const qs = require("qs");

class PostList extends Component {
  static propTypes = {
    posts: PropTypes.any.isRequired,
    section: PropTypes.string,
    tag: PropTypes.string,
    pagination: PropTypes.object,
    loadObjects: PropTypes.func,
    loading: PropTypes.bool,
    previousPage: PropTypes.number,
    limit: PropTypes.number,
    containerProps: PropTypes.object
  };

  constructor(props) {
    super(props);

    const params = new URLSearchParams(this.props.location.search);

    this.state = {
      page: (params.get("page") * 1) || 1,
      pages: Array.isArray(this.props.posts) ? [] : Object.keys(this.props.posts).map(p => p * 1)
    }
  }

  onVisitNextPage() {
    this.setState({
      page: this.state.page + 1
    }, () => {
      let params = qs.parse(window.location.search.substring(1));
      params.page = this.state.page;

      this.props.history.push(this.props.location.pathname + "?" + qs.stringify(params));
    });
  }

  onVisitPrevPage() {
    this.props.loadObjects({
      previous: true,
      page: this.props.previousPage
    });
  }

  componentDidUpdate(prevProps, prevState) {
    if (typeof this.props.loadObjects !== "function") {
      return;
    }

    let currentParams = new URLSearchParams(this.props.location.search);
    let oldParams = new URLSearchParams(prevProps.location.search);

    if (currentParams.get("page") !== oldParams.get("page")) {
      this.props.loadObjects();
    }
  }

  render() {
    const { posts, section, tag, pagination, loading, previousPage, containerProps } = this.props;
    const { pages } = this.state;

    const merged = Array.isArray(posts) ? posts : [].concat.apply([], Object.values(posts)).filter(o => !!o);

    return (
      <React.Fragment>
        {pagination && tag && <div className={'row'}><div className={'col-12 col-lg-6 offset-lg-3'}><SubscribeButton tag={tag} className={"mb-3"} loadSubscribed={true} /></div></div>}
        {loading && <Loader type={'side'} />}
        {!loading && previousPage > 0 && !pages.includes(previousPage) && (
          <div className={'text-center'}><button onClick={this.onVisitPrevPage.bind(this)} className={'btn btn-default mb-3'}>Load previous Page</button></div>
        )}
        {!loading || merged.length > 0 ? (
          <div className={'row vertical-gutters'}>
            {merged.map((post, idx) => {
              return (
                <React.Fragment key={post.slug}>
                  <div className={'col-6 col-lg-3'}>
                    <Container {...(containerProps || {})} post={post} section={section} tag={tag} />
                  </div>
                  {pagination && ((idx + 1) % (this.props.limit || 32) === 0) && (
                    <div className={'col-12'}>
                      <SwitchingBanner />
                    </div>
                  )}
                </React.Fragment>
              )
            })}

            {merged.length <= 0 && <div className={'col-12 text-center font-weight-bold mt-3'}>There are no posts here :(</div>}
          </div>
        ) : (
          <SkeletonList limit={this.props.limit || 32} imageSize={containerProps && containerProps.imageSize ? containerProps.imageSize : "large"} layout={containerProps && containerProps.layout ? containerProps.layout : "default"} />
        )}
        {!loading && pagination && pagination.count > 0 && pagination.next > pagination.current && (
          <VisibleEvent inViewport={this.onVisitNextPage.bind(this)}>
            <div className={'text-center mt-3'}><button className={'btn btn-default'} onClick={this.onVisitNextPage.bind(this)}>Load next Page</button></div>
          </VisibleEvent>
        )}
      </React.Fragment>
    );
  }
}

export default withRouter(PostList);